import { setLocation } from 'utils/wrappers';

import CreateCarrierAccountModal from 'app/views/modals/create_carrier_account_modal';

import Base from 'app/views/base';

import tmpl from './item_template';

export default Base.extend({
  compiledTemplate: tmpl,

  events: {
    'click.carrier_type': 'carrierAccountListItemClicked',
  },

  initialize({ carrierAccounts }) {
    this.carrierAccounts = carrierAccounts;
    this.createCarrierAccountModal = new CreateCarrierAccountModal({
      model: this.model,
      collection: this.carrierAccounts,
    });
  },

  context() {
    return {
      readable: this.model.get('readable'),
      type: this.model.get('type'),
    };
  },

  carrierAccountListItemClicked(event) {
    event.preventDefault();
    if (this.model.get('fields').custom_workflow) {
      setLocation(`/carrier-custom-workflow/${this.model.get('type')}`);
    } else {
      this.createCarrierAccountModal.show();
    }
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/carrier_accounts/add_carrier_account/item.js